interface ActionButtonsProps {
  onDiscard: () => void;
  onPublish: () => void;
  canDiscard: boolean;
  canPublish: boolean;
  isPublishing: boolean;
  publishButtonText: string;
  publishButtonTextLoading: string;
}

/**
 * Action buttons component for RecorderPanel.
 * Shows Re-record and Publish buttons.
 */
export function ActionButtons({
  onDiscard,
  onPublish,
  canDiscard,
  canPublish,
  isPublishing,
  publishButtonText,
  publishButtonTextLoading,
}: ActionButtonsProps) {
  return (
    <div className="mt-9 mb-0 flex gap-4">
      {/* Ghost Button (Discard) */}
      <button
        className="flex-1 rounded-full border border-[#262636] bg-[#0a0a12] px-3.5 py-2.5 text-[13px] text-[#a3a3c2] transition hover:bg-[#171726]"
        onClick={onDiscard}
        disabled={!canDiscard}
      >
        Discard
      </button>
      {/* Primary Button (Publish) - Mockup Exact Gradient */}
      <button
        className={`flex-1 rounded-full px-3.5 py-2.5 text-[13px] font-semibold transition ${
          canPublish
            ? "bg-gradient-to-r from-[#ff3ea5] to-[#ff6ac2] text-[#160513] shadow-[0_12px_36px_rgba(255,62,165,0.6)] hover:brightness-[1.06] hover:translate-y-[-1px] hover:shadow-[0_16px_44px_rgba(255,62,165,0.8)]"
            : "bg-white/20 text-white/60"
        }`}
        onClick={onPublish}
        disabled={!canPublish}
      >
        {isPublishing ? publishButtonTextLoading : publishButtonText}
      </button>
    </div>
  );
}
